import AppProd from "./App.prod";
import AppDev from "./App.dev";
import "styles/index.scss";

export default ["production", "test"].includes(process.env.NODE_ENV)
  ? AppProd
  : AppDev;
